"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var Product = require('../../../products/interfaces/Product');

var _require = require('../../helpers'),
    isWrapper = _require.isWrapper;

function GlueDotsDetails(_ref) {
  var products = _ref.products,
      children = _ref.children;
  var quantity = 0;
  products.forEach(function (product) {
    return product.subcomponents().forEach(function (component) {
      if (isWrapper(component)) {
        quantity += component.quantity;
      }
    });
  });

  if (quantity === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("span", null, "Glue Dots Qty: ", Math.ceil((parseFloat(quantity) + 3) / 12), /*#__PURE__*/React.createElement("br", null), children);
}

GlueDotsDetails.propTypes = {
  products: PropTypes.arrayOf(PropTypes.instanceOf(Product)),
  children: PropTypes.any
};
module.exports = GlueDotsDetails;